import { LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { effect } from "@preact/signals-core";
import { ButtonState, getCardSignals } from "../store/collection-store";

@customElement("card-background")
export class CardBackground extends LitElement {
  @property({ type: String, attribute: "data-card-id" }) cardId = "";
  @property({ type: String, attribute: "data-in-stock-gradient" })
  inStockGradient =
    "linear-gradient(140deg, var(--color-secondary-50) 0%, var(--color-primary-50) 100%)";
  @property({ type: String, attribute: "data-unavailable-gradient" })
  unavailableGradient =
    "linear-gradient(120deg, var(--color-secondary-100) 0%, var(--color-secondary-100) 100%)";

  private _disposeEffect?: () => void;

  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }

  connectedCallback() {
    super.connectedCallback();

    this._disposeEffect = effect(() => {
      if (!this.cardId) return;

      const card = this.closest("product-card");
      if (!card) return;

      const cardBody = card.querySelector<HTMLElement>("[data-card-body]");
      if (!cardBody) return;

      const signals = getCardSignals(this.cardId);
      if (!signals) return;

      const state = signals.buttonState.value;
      cardBody.style.background = this._isUnavailableState(state)
        ? this.unavailableGradient
        : this.inStockGradient;
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this._disposeEffect) this._disposeEffect();
  }

  private _isUnavailableState(state: ButtonState): boolean {
    return state !== "addToCart" && state !== "clickToBuy" && state !== "limitReached";
  }

  render() {
    return null;
  }
}
